import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";

export const emptyPerson = { name: "", email: "", phone: "", password: "" };

export function PersonForm({ value, onChange, prefix }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Field label="Full name"><Input value={value.name} onChange={(e) => set("name", e.target.value)} data-testid={`${prefix}-name-input`} /></Field>
      <Field label="Phone"><Input value={value.phone} onChange={(e) => set("phone", e.target.value)} data-testid={`${prefix}-phone-input`} /></Field>
      <Field label="Email"><Input type="email" value={value.email} onChange={(e) => set("email", e.target.value)} data-testid={`${prefix}-email-input`} /></Field>
      <Field label="Temporary password (min 8)"><Input type="text" value={value.password} onChange={(e) => set("password", e.target.value)} data-testid={`${prefix}-password-input`} /></Field>
    </div>
  );
}
